const CHROME_EXTENSION_PACKAGE_ID = 'npciikilfcggljgdkebakdcccmkdmpik';

export const CHROME_EXTENSION_STORE_URL = `https://chrome.google.com/webstore/detail/super-dispatch-importer/${CHROME_EXTENSION_PACKAGE_ID}`;

export function hasSuperDispatchExtensionInstalled() {
  // Extension adds 'data-extension-loaded' attribute to the document's root element when it initializes
  return document.documentElement.hasAttribute('data-extension-loaded');
}
